import { useState, useEffect } from 'react';
import { ProductDetailPage } from './store/ProductDetailPage';
import { DesktopProductDetailPage } from './desktop/DesktopProductDetailPage';

export function ResponsiveProductDetailPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <ProductDetailPage /> : <DesktopProductDetailPage />;
}